import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2, Zap, ShieldCheck, Network } from "lucide-react";
import { Reveal, CountUp } from "./motion";

export default function HomeCTA() {
  return (
    <section className="vw-section bg-white" data-testid="home-cta-section">
      <div className="vw-container">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <div className="vw-overline mb-4">Current Opportunities</div>
              <h2 className="font-display text-4xl lg:text-6xl font-semibold text-[var(--vw-navy)] tracking-tight leading-[1.02]">
                Live opportunities are shared with suitable Delivery Partners.
              </h2>
              <p className="mt-6 text-[var(--vw-muted)] text-base lg:text-lg leading-relaxed max-w-xl">
                Verified Workforce works with construction clients across planned
                maintenance, refurbishment and specialist work packages. Live opportunities
                are shared with suitable Delivery Partners based on trade, location,
                capacity, compliance status and project requirements.
              </p>
              <div className="mt-10 flex flex-wrap gap-3">
                <Link to="/opportunities" className="vw-btn vw-btn--navy" data-testid="home-opportunities-btn">
                  View Opportunities
                  <ArrowUpRight size={16} />
                </Link>
                <Link to="/delivery-partners#apply" className="vw-btn vw-btn--outline-dark" data-testid="home-join-network-btn">
                  Join the Delivery Network
                </Link>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <div className="grid grid-cols-2 gap-5">
                <StatCard icon={<ShieldCheck size={22} />} label="Vetted" value={<><CountUp to={100} />%</>} caption="Supply chain reviewed" />
                <StatCard icon={<Zap size={22} />} label="Mobilise" value={<><CountUp to={24} />h</>} caption="Rapid partner matching" />
                <StatCard icon={<Network size={22} />} label="Trades" value={<><CountUp to={24} />+</>} caption="Specialisms covered" />
                <StatCard icon={<CheckCircle2 size={22} />} label="Coverage" value="UK" caption="Nationwide network" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}

function StatCard({ icon, label, value, caption }) {
  return (
    <div className="vw-card p-7">
      <div className="flex items-center gap-3 text-[var(--vw-blue)]">
        <span className="w-10 h-10 bg-[var(--vw-blue)]/10 flex items-center justify-center">{icon}</span>
        <span className="vw-overline">{label}</span>
      </div>
      <div className="mt-6 font-display text-4xl lg:text-5xl font-semibold text-[var(--vw-navy)] tracking-tight">
        {value}
      </div>
      <div className="mt-2 text-sm text-[var(--vw-muted)]">{caption}</div>
    </div>
  );
}
